import { useCallback } from 'react';

import styles from '../styles/IconLibrary.module.css';

type TagProps = { label: string; onClick?: (tag: string) => void; active?: boolean };
export const Tag = ({ label, onClick, active = false }: TagProps) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(label);
    }
  }, [label, onClick]);
  return (
    <button
      className={`${
        styles.tag
      } bg-white border rounded-xl leading-none border-solid border-darkgray px-2 py-1 select-none cursor-pointer outline-none transition-colors ${
        active && 'bg-gray'
      }`}
      onClick={handleClick}
    >
      <span className="leading-none text-xs text-current">{label}</span>
    </button>
  );
};
